<template>
  <v-card
    class="spin-card card-wrapper d-flex flex-column justify-space-between"
    tile
    flat
  >
    <v-card-text align="center" class="mt-16">
      <a :href="content.link" target="_blank">
        <v-img width="200px" contain :src="getImageURI(content.image)"></v-img
      ></a>
    </v-card-text>

    <div>
      <!-- <v-card-text>
        <p class="pa-0 ma-0">
          <a :href="content.link" target="_blank">{{ content.link }}</a>
        </p>
        <p class="pa-0 ma-0">
          <a :href="'mailto:' + content.email">{{ content.email }}</a>
        </p>
      </v-card-text> -->

      <v-expand-transition>
        <v-card
          tile
          flat
          v-if="show"
          v-click-outside="onClickOutside"
          class="transition-fast-in-fast-out v-card--reveal more-info"
        >
          <v-card-text class="pb-0">
            <div v-html="content.description"></div>
            <div class="mt-2">{{ content.email }}</div>
          </v-card-text>
        </v-card>
      </v-expand-transition>

      <v-card-actions
        class="d-flex justify-space-between"
        @click="show = !show"
      >
        <v-btn color="green" text>Info</v-btn>
        <v-btn icon>
          <v-icon color="green">{{ show ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'RecognizedSpinOffCard',
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    onClickOutside() {
      this.active = false
    },

    getImageURI(imageName) {
      if (imageName) {
        return require(`../assets/images/academics/${imageName}`)
      }
      return 'https://cdn.vuetifyjs.com/images/cards/house.jpg'
    },
  },
}
</script>

<style lang="scss">
.spin-card {
  border: 1px solid #878a8c !important;
  height: 360px;

  .card-title {
    font-family: $heading-font-family;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    text-transform: uppercase;
    overflow-wrap: normal;
    word-break: normal;
  }
  a {
    text-decoration: none !important;
    color: #1bb493 !important;
  }
  .more-info {
    position: absolute;
    bottom: 50px;
    background-color: rgba(#e4e3e1, 0.98);
    height: 308px;
    overflow: auto;
  }
}
</style>
